import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { RESET } from "jotai/utils";
import { useAuth } from "@/hooks/useAuth";
import { storedShipToLocationIdAtom } from "@/store/shipToAtoms";
import { recentSearchesAtom } from "@customer/Search/store/searchAtoms";

// The one explicit sign-out (PO ruling, 2026-09-28). Clears every value kept in
// localStorage for the signed-in user, then signs out. Here and not in
// endSessionAtom: that reset also runs on every page load, where MSAL reports
// signed-out for one render, and a reload must not wipe these. RESET removes the
// storage key, and localStorage is shared, so every open tab loses them too.
// In-memory account data is cleared by useEndSessionOnSignOut once MSAL reports
// the account gone.
export const useSignOut = () => {
    const { instance } = useAuth();
    const setStoredShipToLocationId = useSetAtom(storedShipToLocationIdAtom);
    const setRecentSearches = useSetAtom(recentSearchesAtom);

    return useCallback(() => {
        setStoredShipToLocationId(RESET);
        setRecentSearches(RESET);
        instance.logoutPopup();
    }, [instance, setStoredShipToLocationId, setRecentSearches]);
};
